import { render, staticRenderFns } from "./MessageTicket.vue?vue&type=template&id=4cb2915c"
import script from "./MessageTicket.vue?vue&type=script&lang=js"
export * from "./MessageTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports